import clsx from 'clsx'
import * as React from 'react'
import { styled } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

import { classToFComponent, FCClassContext, ToolbarDivider } from 'src/utils/views'
import { HeaderScope } from '../overview_scopes'

const SectionTitle = styled('div')({
    minWidth: 0,
    color: 'var(--green)',
    fontSize: 17,
    fontWeight: 600,
    letterSpacing: '.01em',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '@media (max-width: 900px)': { fontSize: 15 }
})

const useStyles = makeStyles()(() => ({
    view: {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: 12,
        marginLeft: 5,
        minWidth: 0
    }
}))

type HeaderProps = {
    className?: string
    scope: HeaderScope
}

class HeaderViewClass implements FCClassContext<HeaderProps> {
    // :: Fields

    scope!: HeaderScope

    // :: Emissors

    // <EMPTY>

    // :: Methods

    onSyncState({ scope }: HeaderProps) {
        this.scope = scope
    }

    render(props: HeaderProps): React.JSX.Element {
        const classes = useStyles().classes

        return (
            <div className={clsx(classes.view, props.className)}>
                <ToolbarDivider orientation="vertical" variant="middle" flexItem />
                <SectionTitle>Início</SectionTitle>
            </div>
        )
    }
}
export const HeaderView = classToFComponent(HeaderViewClass, React)
export default HeaderView
